import { Routes } from '@angular/router';
import { ProxyPageComponent } from '@context/frontend/common';
import { ExternalViewAuthGuard } from '@context/frontend/user';
import { environment } from '../environments/environment';
import { ViewerShellComponent } from './layout/viewer-shell.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { externalContentGuard } from './pages/view/external-content.guard';
import { externalContentResolver } from './pages/view/external-content.resolver';
import { ExternalFileViewComponent } from './pages/view/external-file-view/external-file-view.component';
import { ExternalFolderViewComponent } from './pages/view/external-folder-view/external-folder-view.component';
import { ExternalViewProxyComponent } from './pages/view/external-view-proxy.component';

export const appRoutes: Routes = [
	{
		// Share-link entry point. The auth guard validates the link and establishes
		// the share session exactly once; the proxy component then forwards to the
		// content stack below. Kept separate from that stack so descendant
		// navigation never re-triggers this guard.
		path: 'view/:externalId',
		canActivate: [ExternalViewAuthGuard],
		component: ExternalViewProxyComponent,
	},
	{
		// The actual viewer, in its own route stack. Navigating between folders and
		// files only re-resolves the child content - the proxy's guard above is not
		// part of this tree, so it never runs again.
		path: 'content/:externalId',
		canActivate: [externalContentGuard],
		component: ViewerShellComponent,
		children: [
			{
				path: 'folder/:id',
				component: ExternalFolderViewComponent,
				resolve: { content: externalContentResolver },
				runGuardsAndResolvers: 'paramsChange',
			},
			{
				path: 'file/:id',
				component: ExternalFileViewComponent,
				resolve: { content: externalContentResolver },
				runGuardsAndResolvers: 'paramsChange',
			},
		],
	},
	{
		path: 'logout',
		component: LogoutComponent,
	},
	{
		path: '',
		component: ProxyPageComponent,
		data: {
			proxyPage: {
				defaultTitleKey: 'external.landing.title',
				defaultDescriptionKey: 'external.landing.description',
				redirectUrl:
					environment.portalUrl ??
					(environment.production
						? 'https://app-context.com'
						: 'https://dev.app-context.com'),
			},
		},
	},
	{
		path: '**',
		redirectTo: '',
	},
];
